/* HSF — lecteur podcast : charge les derniers épisodes Apple Podcasts et met le plus récent en avant */
(function(){
  var player=document.querySelector('.hh-pod .player');if(!player)return;
  var frame=player.querySelector('iframe');var ID='1802343711';
  var cb='hsfPod'+Date.now();
  window[cb]=function(d){
    try{
      var eps=(d.results||[]).filter(function(r){return r.wrapperType==='podcastEpisode'}).slice(0,5);
      if(!eps.length)return;
      var ul=document.createElement('ul');ul.className='hh-eps';
      function emb(u){return u.replace('https://podcasts.apple.com','https://embed.podcasts.apple.com').replace(/[?&]uo=\d+/,'')}
      eps.forEach(function(e,i){
        var li=document.createElement('li');
        var dt=new Date(e.releaseDate).toLocaleDateString('fr-FR',{day:'numeric',month:'long'});
        li.innerHTML='<span class="no">'+String(i+1).padStart(2,'0')+'</span><span class="t"></span><span class="d">'+dt+'</span><span class="pl">▶</span>';
        li.querySelector('.t').textContent=e.trackName;
        li.addEventListener('click',function(){frame.src=emb(e.trackViewUrl);[].forEach.call(ul.children,function(x){x.classList.remove('on')});li.classList.add('on');});
        ul.appendChild(li);
      });
      frame.src=emb(eps[0].trackViewUrl);ul.firstChild.classList.add('on');
      player.appendChild(ul);
    }catch(e){}
  };
  var s=document.createElement('script');
  s.src='https://itunes.apple.com/lookup?id='+ID+'&entity=podcastEpisode&limit=6&country=fr&callback='+cb;
  document.body.appendChild(s);
})();
